import { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/authContexts";

const ProtectedRoute = ({ roles = [], permissions = [] }) => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        if (!loading) {
            if (!user) {
                navigate("/", { replace: true });
            } else if (!user.role) {
                navigate("/403", { replace: true });
            } else {
                const rolesArray = Array.isArray(user.role) ? user.role : (user.role ? [{ name: user.role.name }] : []);
                const permissionsArray = Array.isArray(user.permissions) ? user.permissions : [];

                const tieneRol = rolesArray.some(role => roles.includes(role.name));
                const tienePermisos = permissions.every(permission =>
                    permissionsArray.some(p => p.name === permission)
                );

                if (!tieneRol || !tienePermisos) {
                    if (rolesArray.some(role => role.name === "Soporte")) {
                        if (permissionsArray.some(p => p.name === "manage-technician")) return navigate("/Control-Tecnico", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-partners")) return navigate("/Tecnicos-Partner", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-clients")) return navigate("/Control-cliente", { replace: true });
                        if (permissionsArray.some(p => p.name === "view-manage-actividade")) return navigate("/Actividades", { replace: true });
                        return navigate("/403", { replace: true });
                    }
                    if (rolesArray.some(role => role.name === "Administrativo")) {
                        if (permissionsArray.some(p => p.name === "access-dashboard")) return navigate("/Home", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-users-roles")) return navigate("/Categorias", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-categories")) return navigate("/Categoria", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-technician")) return navigate("/Control-Tecnico", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-partners")) return navigate("/Tecnicos-Partner", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-clients")) return navigate("/Control-cliente", { replace: true });
                        if (permissionsArray.some(p => p.name === "view-publicity")) return navigate("/Publicidad", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-subcription")) return navigate("/Suscripciones", { replace: true });
                        if (permissionsArray.some(p => p.name === "view-manage-actividade")) return navigate("/Actividades", { replace: true });
                        if (permissionsArray.some(p => p.name === "reports")) return navigate("/Reportes", { replace: true });
                        return navigate("/403", { replace: true });
                    }
                    if (rolesArray.some(role => role.name === "Comercial")) {
                        if (permissionsArray.some(p => p.name === "view-publicity")) return navigate("/Publicidad", { replace: true });
                        if (permissionsArray.some(p => p.name === "manage-subcription")) return navigate("/Suscripciones", { replace: true });
                        return navigate("/403", { replace: true });
                    }
                    return navigate("/403", { replace: true });
                }
            }

            setChecking(false);
        }
    }, [loading, user, navigate, roles, permissions]);

    if (loading || checking) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
            </div>
        );
    }

    return <Outlet />;
};
export default ProtectedRoute;